module.exports = __webpack_public_path__ + "img/1.20c5ceea.svg";